import { render } from "./StoreCartCollectionModule.vue?vue&type=template&id=4a12472b&scoped=true"
import script from "./StoreCartCollectionModule.vue?vue&type=script&lang=js"
export * from "./StoreCartCollectionModule.vue?vue&type=script&lang=js"

import "./StoreCartCollectionModule.vue?vue&type=style&index=0&id=4a12472b&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a12472b"]])

export default __exports__